module.exports = __webpack_public_path__ + "img/lissajoux_sound.a24ed1cd.gif";